(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hogare-sticky-buy-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    function initHogareStickyBuy(root) {
      if (root.dataset.hogareStickyBuyReady) return;
      var bar = root.querySelector('.hogare-sticky-buy__bar');
      var cta = root.querySelector('[data-hogare-sticky-buy-cta]');
      var trigger = document.querySelector('.product-information .product-details');
      if (!bar || !cta || !trigger) return;
      root.dataset.hogareStickyBuyReady = 'true';

      // Shown whenever the inline CTA beside the gallery (hogare-inline-cta.liquid) is out of
      // view — hidden while it's visible, so there's never two identical "Solicita Aquí, Paga
      // en Casa" buttons on screen at once. On templates/breakpoints without that block, this
      // bar just shows immediately and stays shown.
      function updateVisibility(inlineCtaVisible) {
        var shouldShow = inlineCtaVisible !== true;
        if (shouldShow) {
          root.classList.add('hogare-sticky-buy--active');
          bar.dataset.stuck = 'true';
        } else {
          root.classList.remove('hogare-sticky-buy--active');
          bar.dataset.stuck = 'false';
        }
      }

      var inlineCta = document.querySelector('[data-hogare-inline-cta]');
      if (inlineCta && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            updateVisibility(entry.isIntersecting);
          });
        });
        observer.observe(inlineCta);
      } else {
        updateVisibility(false);
      }

      cta.addEventListener('click', function () {
        var realButton = trigger.querySelector('#rsi_buy_now_button') || document.querySelector('#rsi_buy_now_button');
        if (realButton) {
          realButton.click();
        }
      });
    }

    function initAll() {
      document.querySelectorAll('[data-hogare-sticky-buy]').forEach(initHogareStickyBuy);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
